import processEnvSystem from 'unlikely-env/system'

const IS_NODE_DEV = processEnvSystem('NODE_ENV') === 'development'

export default IS_NODE_DEV
